import { useQuery } from '@tanstack/react-query';

import { ARGENTINA_ID_DEFAULT, fetchProvincias, type Provincia } from '../api/provincias.api';

export function useProvinciasQuery(idPaisWeb: string = ARGENTINA_ID_DEFAULT) {
  return useQuery<Provincia[], Error>({
    queryKey: ['provincias', idPaisWeb],
    queryFn: () => fetchProvincias(idPaisWeb),
    staleTime: 1000 * 60 * 60,
  });
}
